import script from "./video-player.vue?vue&type=script&setup=true&lang=js"
export * from "./video-player.vue?vue&type=script&setup=true&lang=js"

import "./video-player.vue?vue&type=style&index=0&id=24a0c141&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a0c141"]])

export default __exports__